module.exports = __webpack_public_path__ + "static/media/predictions.22fb0870.svg";